import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { idleService } from '../../shared/services/idle-service';
import { SharedDataService } from '../../shared/services/shared-data-service';
import { sharedBroadcast } from '../../pages/header/header';
import { catchError, Observable, throwError } from 'rxjs';
// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   const publicAPIs = ['api/Login/UserLogin', 'api/Login/UserLoginWithPwd'];
//   const localIdleService = inject(idleService);
//   const localSharedDataService = inject(SharedDataService);
//   // Force logout via broadcast listener
//   // sharedBroadcast.onmessage = (message) => {
//   //   if (message.data === 'logOut-inter') {
//   //     localIdleService.toastMessageSignal.set({
//   //       severity: 'success',
//   //       summary: 'Logout',
//   //       detail: 'You have been forcefully logged out. Please log in again.',
//   //     });
//   //     window.location.reload();
//   //   }
//   // };

//   // Determine if it's a public API
//   const isPublicAPI = publicAPIs.some((url) => req.url.includes(url));

//   // 🔄 Always fetch the token fresh just before it's needed
//   const freshToken = localStorage.getItem('Auth_token');

//   // 📦 Set headers including Authorization only if required
//   const headersConfig: any = {
//     Accept: 'application/json',
//     'Cache-Control': 'no-cache, no-store, must-revalidate',
//     Pragma: 'no-cache',
//     Expires: '0',
//   };
//   // 🚫 If private API and token is missing, block and force logout
//   if (!isPublicAPI && !freshToken) {
//     localIdleService.toastMessageSignal.set({
//       severity: 'success',
//       summary: 'Logout',
//       detail: 'You have been forcefully logged out. Please log in again.',
//     });
//     localStorage.clear();
//     localIdleService.broadcastMessage('logOut-inter');
//     // sharedBroadcast.postMessage('logOut-inter');
//     window.location.reload();
//     return throwError(() => new Error('No auth token found.'));
//   }

//   if (!isPublicAPI && freshToken) {
//     try {
//       headersConfig.Authorization = JSON.parse(freshToken);
//     } catch (e) {
//       headersConfig.Authorization = freshToken;
//     }
//   }
//   const modifiedReq = req.clone({ setHeaders: headersConfig });
//   return next(modifiedReq).pipe(
//     // retry({
//     //   count: 1, // Retry up to 3 times
//     //   delay: (retryAttempt) => timer(retryAttempt * 1000) // Add a delay (e.g., 1s, 2s, 3s)
//     // }),
//     catchError((error) =>
//       handleHttpError(error, localIdleService, localSharedDataService, isPublicAPI)
//     )
//   );
// };

// function handleHttpError(
//   error: any,
//   idleService: idleService,
//   sharedService: SharedDataService,
//   isPublicAPI: boolean
// ): Observable<never> {
//   console.error('HTTP Error:', error);

//   const ERROR_MESSAGES = {
//     UNAUTHORIZED: 'Unauthorized access. Logging out...',
//   };

//   switch (error.status) {
//     case 401:
//       if (!sharedService.isLogoutInitiated() && !isPublicAPI) {
//         console.warn(ERROR_MESSAGES.UNAUTHORIZED);
//         sharedService.setLogoutInitiated(true);
//         idleService.broadcastMessage('logOut-inter');
//         idleService.logout('Unauthorized');
//       }
//       break;
//   }
//   return throwError(() => error);
// }

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const publicAPIs = ['api/Login/UserLogin', 'api/Login/UserLoginWithPwd'];

  const currentUrl = window.location.pathname.toLowerCase();
  const publicPages = ['/dashboard', '/login', '/hardware-details', '/product-details'];
  const isPublicPage = publicPages.some((page) => currentUrl.includes(page));

  const localIdleService = inject(idleService);
  const localSharedDataService = inject(SharedDataService);

  const isPublicAPI = publicAPIs.some((url) => req.url.includes(url));

  const freshToken = localStorage.getItem('Auth_token');

  const headersConfig: any = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  };

  if (freshToken) {
    try {
      headersConfig.Authorization = JSON.parse(freshToken);
    } catch (e) {
      headersConfig.Authorization = freshToken;
    }
  } else {
    headersConfig.Authorization = '-1';
  }

  const modifiedReq = req.clone({ setHeaders: headersConfig });

  return next(modifiedReq).pipe(
    catchError((error) =>
      handleHttpError(error, localIdleService, localSharedDataService, isPublicAPI || isPublicPage),
    ),
  );
};

function handleHttpError(
  error: any,
  idleService: idleService,
  sharedService: SharedDataService,
  isPublicAPI: boolean,
): Observable<never> {
  console.error('HTTP Error:', error);

  const ERROR_MESSAGES = {
    UNAUTHORIZED: 'Unauthorized access. Logging out...',
  };

  switch (error.status) {
    case 401:
      // ✅ Don't logout for public APIs/pages
      if (!sharedService.isLogoutInitiated() && !isPublicAPI) {
        console.warn(ERROR_MESSAGES.UNAUTHORIZED);
        sharedService.setLogoutInitiated(true);
        idleService.broadcastMessage('logOut-inter');
        idleService.logout('Unauthorized');
      }
      break;
  }
  return throwError(() => error);
}
